<template>
  <div class="wrapper flex">
    <div class="left flexnone">
      <Input placeholder="搜索" @on-change="setTreeData"
             v-model="searchText"/>
      <Tree :data="treeData" ref="tree" @on-select-change="treeChange"></Tree>
    </div>
    <div class="right flexauto page-wrapper" style="padding-top: 0;overflow:hidden">
      <search-list @findData="findData" @clear="clearValue" ref="search"></search-list>

      <Button type="primary" class="mb16" @click.stop="toAdd"
              v-p="{api:'user/addUser'}"
      >添加</Button>
      <table-list
        title="" :columns="columns" :data="dataTable"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
      <add :n="addN" :updateUid="updateUid" :positionOptions="positionOptions"
           @done="init" @close="close"></add>
      <extent :n="extentN" :extentUid="extentUid"></extent>
      <check-user :n="checkN" :checkUid="checkUid"
           @close="close"></check-user>
    </div>

  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import CheckUser from './components/CheckUser'
  import SearchList from './components/SearchList'
  import {setTitleAndOthers, filterArr,setFirstSelected, setSelectedFromData} from "../js/systemmanage";
  import {organTree} from "../../../api/systemmanage";
  import {getUserList, updateUserDeparture, updateUserState, getPosition,deleteUserInfo} from "../../../api/user";
  import {deepClone} from "../../../utils/format";
  import Extent from './components/Extent'
  import {formatDateTime} from "@//utils/format"
  import {deleteAssetsInfo} from "api/assets";

  export default {
    name: "user",
    components:{
      TableList,
      Add,
      SearchList,
      CheckUser,
      Extent
    },
    data () {
      return {
        updateData:null,
        extentN:0,
        treeData:[],
        searchText:'',
        updateUid:'',
        checkUid:'',
        extentUid:'',
        addN:0,
        checkN:0,
        data: [],
        searchedId: '',
        searchData: {
          state: '',
          departure: 1,
          nameOrPhone: '',
          organUid:'',
          pageSize: 10,
          page: 1,
        },
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        columns:[
          {
            type:'index',
            width:60,
          },
          {title:' '},
          {
            title:'姓名',
            key:'nickName',
            align:'center',
            width:100,
            render:(h,param)=>{
              return h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'user/getUserDetail'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.checkUid=param.row['uid'];
                    this.checkN++
                  }
                }
              },param.row['nickName'])
            }
          },
          {title:' '},
          {
            title:'籍贯' ,
            key:'hometown',
            align:'center',
            width:120,
          },
          {title:' '},
          {
            title:'身份证号' ,
            key:'certificateCode',
            align:'center',
            width:180,
          },
          {title:' '},
          {
            title:'角色名称' ,
            key:'newRoleNames',
            align:'center',
            width:180,
            render: (h, params) => {
              const roleNamesStr =params.row['newRoleNames']? params.row['newRoleNames'].join(','):'';
              if (roleNamesStr.length > 10) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, roleNamesStr),
                  h('span', {}, roleNamesStr.slice(0, 10) + '...')
                ])
              }
              else {
                return h('span', {}, roleNamesStr)
              }
            }
          },
          {title:' '},
          {
            title:'用户编码' ,
            key:'uid',
            align:'center',
            width:150,
          },
          {title:' '},
          {
            title:'所属机构',
            key:'organNames',
            align:'center',
            width:150,
            render: (h, params) => {
              const organNamesStr =params.row['organNames']? params.row['organNames'].join(','):'';
              if (organNamesStr.length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, organNamesStr),
                  h('span', {}, organNamesStr.slice(0, 7) + '...')
                ])
              }
              else {
                return h('span', {}, organNamesStr)
              }
            }
          },
          {title:' '},
          {
            title:'管辖范围' ,
            key:'',
            align:'center',
            render:(h,params)=>{
              return h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'user/getConfigDataAuth'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.extentUid=params.row['uid'];
                    this.extentN++
                  }
                }
              },'编辑')
            },
            width:100,
          },
          {title:' '},
          {
            title: '入职时间',
            key: 'entryTime',
            align: 'center',
            render: (h,params) => {
              return h('div',formatDateTime(params.row.entryTime, false))
            },
            width:180,
          },
          {title:' '},
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            render: (h,params) => {
              return h('div',formatDateTime(params.row.createTime, true))
            },
            width:180,
          },
          {title:' '},
          {
            title:'创建人' ,
            key:'creatorName',
            align:'center',
            width:100,
          },
          {title:' '},
          {
            title:'状态' ,
            key:'state',
            align:'center',
            width:80,
            render: (h, params) => {
              return h('span', {}, params.row['state'] === 1 ? '正常' : '锁定')
            },
          },
          {title:' '},
          {
            title:'操作',
            key:'actions',
            align:'center',
            width:130,
            fixed:'right',
            render:(h,params)=>{
              const edit = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'user/updateUser'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.updateUid=params.row.uid;
                    this.$nextTick(()=>{
                      this.addN++
                    })
                  }
                }
              }, '修改');
              const away = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'user/updateUserDeparture'
                    }
                  }
                ],
                style: {
                  marginLeft: '10px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: (params.row['departure']  === 0 ? '复职' : '离职'),
                      content: (params.row['departure']  === 0 ? '确定该用户已复职吗？' : '确定该用户已离职吗，该用户将无法正常登录！'),
                      onOk: () => {
                        const departure = params.row['departure']  === 0 ? 1 : 0;
                        updateUserDeparture({uid: params.row['uid'], departure: departure}).then(
                          res => {
                            this.searchData.page = 1;
                            this.$Message.success((params.row['departure']  === 0 ? '复职' : '离职') + '成功');
                            this.getUserList(this.searchedId)
                          }
                        ).catch(error => {
                        })
                      }
                    })
                  }
                }
              }, params.row['departure']  === 0 ? '复职' : '离职');
              const blockItem = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'user/updateUserState'
                    }
                  }
                ],
                style: {
                  marginLeft: '10px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: (params.row['state']  === 1 ? '锁定' : '解锁'),
                      content: '<span>确认</span>' + (params.row['state']  === 1 ? '确定锁定该用户吗，锁定后将无法正常登录！' : '确定解锁该用户吗？'),
                      onOk: () => {
                        const state = params.row['state']  === 1 ? 4 : 1;
                        updateUserState({uid: params.row['uid'], state: state}).then(
                          res => {
                            this.searchData.page = 1;
                            this.$Message.success((params.row['state']  === 1 ? '锁定' : '解锁') + '成功');
                            this.getUserList(this.searchedId)
                          }
                        ).catch(error => {
                        })
                      }
                    })
                  }
                }
              }, params.row['state']  === 1 ? '锁定' : '解锁');
              const deleteItem = h('a', {
                on: {
                  click: () => {
                    this.deleteItem(params.row.uid);
                    // this.$router.push({path:'/app/seeClockinRecord',query:{id:params.row.uid}});
                  }
                }
              }, '删除');
              return h('div',{},[edit,away,blockItem,deleteItem])
            }
          },
        ],
        positionOptions: []
      }
    },
    methods:{
      treeChange(value){
        if (!value || value.length === 0) {
          return
        }


        const data=this.$refs['search'].searchData

        this.current = 1;
        this.searchData.page = 1
        this.searchData.pageSize=10

        this.searchData.departure=data.departure
        this.searchData.nameOrPhone=data.nameOrPhone
        this.searchData.state=data.state
        this.getUserList(value[0].value)
      },
      init(){
        this.searchData.page = 1;
        this.organTree().then(res => {
          const checked = this.$refs['tree'].getSelectedNodes();
          this.findList(checked)

        }).catch().finally(() => {
        })
        getPosition().then(res => {
          if (!res.data) {
            return
          }
          this.positionOptions = res.data;
        })
      },
      organTree() {
        return organTree().then(res => {
          if (!res.data) {
            return
          }
          const data = res.data;
          setTitleAndOthers(data);
          if(this.searchedId){
            setSelectedFromData(data, this.searchedId)
          }else {
            setFirstSelected(data)
          }
          this.data = data;
          this.treeData = this.data
        }).catch(error => {
        })
      },
      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      findList(value) {
        if (!value || value.length === 0) {
          return
        }
        this.current = 1;
        this.searchData.page = 1
        this.getUserList(value[0].value)
      },

      getUserList(value) {
        this.searchData.organUid = value;
        getUserList(this.searchData).then(res => {
          if (!res.data) {
            return
          }
          this.dataTable = res.data.rows;
          this.total = res.data.total;
          this.searchedId = value
        }).catch(error => {
        })
      },

      findData(params){
        const checked = this.$refs['tree'].getSelectedNodes();
        if(!checked || !checked.length){
          this.$Message.info('请选择组织机构')
          return

        }

        this.searchData = deepClone(params);
        this.current = 1;
        this.searchData.page = 1
        this.searchData.pageSize=10

        this.findList(checked)
      },
      toAdd(){
        this.addN++
      },
      changePage(n){
        this.current = n;
        this.searchData.page = n;
        this.getUserList(this.searchedId)
      },
      close(){
        this.updateUid=null
      },
      clearValue() {
        this.searchData={
          state: '',
          departure: 1,
          nameOrPhone: '',
          organUid:'',
          pageSize: 10,
          page: 1,
        }
      },
      deleteItem(uid){
        this.$Modal.confirm({
          title:'确定删除用户',
          content:'<p>确认删除本用户？</p>',
          onOk:()=>{
            let params={
              uid:uid
            }
            deleteUserInfo(params).then(res=>{
              this.searchData.page = 1;
              this.$Message.success('删除成功');
              this.getUserList(this.searchedId)
            }).catch(error=>{})
          }
        })
      }
    },
    created(){
      this.init()
    }
  }
</script>

<style scoped>
  .wrapper{
    /*display: flex;*/
  }

  .left{
    /*flex: none;*/
    width: 200px;
    /*height: 100%;*/
    height: 80vh;
    box-sizing: border-box;
    overflow: auto;
    padding: 10px;
    border: 1px solid #dcdcdc;
    /*background-color: lightgray;*/
    margin-right: 10px;

  }
  .right{
    overflow: auto;

  }


</style>
